import { AuthProvider, useAuth } from "./AuthContext";
import UserContext from "./UserContext";
import { BiensProvider } from "./BiensContext";
import { ContactsProvider } from "./ContactsContext";
import { NegosProvider } from "./NegosContext";

function UserContextBridge({ children }) {
  const { userId } = useAuth();

  return <UserContext.Provider value={userId}>{children}</UserContext.Provider>;
}

function DataProviders({ children }) {
  return (
    <BiensProvider>
      <ContactsProvider>
        <NegosProvider>{children}</NegosProvider>
      </ContactsProvider>
    </BiensProvider>
  );
}

export default function AppProviders({ children }) {
  return (
    <AuthProvider>
      <UserContextBridge>
        <DataProviders>{children}</DataProviders>
      </UserContextBridge>
    </AuthProvider>
  );
}
